import {
	Casino,
	EmojiEvents,
	Feedback,
	LocalOffer,
	PeopleOutlined,
	Person,
	Redeem,
	School,
	Tv,
	Settings,
	Videocam,
	CalendarToday,
	SportsSoccerOutlined,
	TimelapseOutlined,
	CategoryOutlined,
	StoreMallDirectory
} from '@mui/icons-material';

export const NO_AUTH_ROUTES = [
	'/',
	'/login',
	'/forgot_password',
	'/verify_pin',
	'/reset_password'
];

export const MENU_ITEMS = {
	loggedIn: [
		{
			title: 'User Information',
			icon: Person,
			items: [
				{ text: 'Users', value: '/users' },
				{ text: 'Benchmark Submissions', value: '/benchmark-submissions' },
				{ text: 'Videos', value: '/videos' }
			]
		},

		// Training
		{
			title: 'Training',
			icon: TimelapseOutlined,
			items: [
				{ text: 'Lessons', value: '/lessons' },
				{ text: 'Benchmark Drills', value: '/training-plan-drills' },
				{ text: 'Trainers', value: '/trainers' }
			]
		},

		{
			title: 'Promotional',
			icon: Redeem,
			items: [
				// { text: 'Promo Codes', value: '/promo_codes' },
				// { text: 'Rewards', value: '/rewards' },
				{ text: 'Member Benefits', value: '/benefits' }
				// { text: 'Lotteries', value: '/lotteries' }
			]
		},

		{
			title: 'Community',
			icon: PeopleOutlined,
			items: [
				{ text: 'Partners', value: '/partners' },
				{ text: 'Academies', value: '/academies' },
				{ text: 'Events', value: '/events' },
				{ text: 'In-Person Events', value: '/in-person-events' },
				{ text: 'Editorials', value: '/editorials' },
				{ text: 'Topics', value: '/topics' }
			]
		},

		{
			title: 'Categories',
			icon: CategoryOutlined,
			items: [
				{ text: 'Skills Category', value: '/categories' },
				{ text: 'Positions', value: '/positions' }
			]
		},
		{
			title: 'Store',
			icon: StoreMallDirectory,
			items: [
				{ text: 'Coin Rates', value: '/coin-rates' },
				{ text: 'Cost Items', value: '/cost-items' },
				{ text: 'Earn Items', value: '/earn-items' }
			]
		},

		{
			title: 'Settings',
			icon: Settings,
			items: [{ text: 'Settings', value: '/settings' }]
		}
	],

	loggedOut: [
		{
			title: 'Auth',
			items: [
				{ text: 'Sign In', value: '/login' },
				{ text: 'Reset password', value: '/forgot_password' }
			]
		}
	]
};
